import { render, staticRenderFns } from "./table-skeleton.vue?vue&type=template&id=ec231f14&scoped=true&"
import script from "./table-skeleton.vue?vue&type=script&lang=js&"
export * from "./table-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./table-skeleton.vue?vue&type=style&index=0&id=ec231f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec231f14",
  null
  
)

export default component.exports